export const THEME_KEY = 'theme';

export function readStoredTheme() {
  try {
    const stored = window.localStorage.getItem(THEME_KEY);
    if (stored === 'dark') return 'dark';
    if (stored === 'light') return 'light';
    return 'dark';
  } catch {
    return 'dark';
  }
}

export function applyTheme(theme) {
  const next = theme === 'dark' ? 'dark' : 'light';
  try {
    window.localStorage.setItem(THEME_KEY, next);
  } catch {
    // private mode: class still updates for this session
  }
  document.documentElement.classList.toggle('dark', next === 'dark');
  return next;
}
